import { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Avatar, Box, Grid, Typography, useMediaQuery } from '@mui/material'
import {
  retrieveSystemAdminUserByID as systemGetUser,
  updateSelectedSystemAdminUserStore,
  systemAdminUsersChangeStatus as systemChangeStatus,
} from '../../redux/features/users/SystemAdminUsers/SystemAdminUsersThunk'
import {
  customerAdminUpdateSelectedUser,
  retrieveCustomerAdminUserByID,
} from '../../redux/features/users/customerAdmin/customerAdminThunk'
import { customerAdminSelectUsers } from '../../redux/features/users/customerAdmin/customerAdminSlice'
import defaultImage from '../../images/default-image.svg'
import completeInfoImage from '../../images/complete-profile-art.svg'
import OfoqThemeBtn from '../../components/Buttons/OfoqThemeBtn.jsx'
import SwitchBtn from '../../components/Buttons/SwitchBtn.jsx'
import GoBackButton from '../../components/Buttons/GoBackButton.jsx'
import { getUserName, isNotEmpty } from '../../utils/helpers'
import FormModalContainer from '../../components/Modals/FormModalContainer.jsx'
import CookiesStorageService from '../../services/CookiesStorageService'
import UseTranslation from '../../hooks/UseTranslation.jsx'
import HoverTooltip from '../../components/PageHelpers/HoverTooltip.jsx'
import { selectSystemAdminUsers } from '../../redux/features/users/SystemAdminUsers/SystemAdminUsersSlice'

const Index = () => {
  const adminType = CookiesStorageService.getAdminType()
  const isSmScreen = useMediaQuery((theme) => theme.breakpoints.down('lg'))

  const baseUri = process.env.REACT_APP_ROOT_ROUTE || ''

  const { id } = useParams()
  const history = useHistory()
  const dispatch = useDispatch()
  const { t } = UseTranslation()
  const user = useSelector(
    adminType === 'sys_admin' ? selectSystemAdminUsers : customerAdminSelectUsers,
  ).updatedUser

  const [userRolesClone, setUserRolesClone] = useState([])
  const [modelState, setModelState] = useState(false)
  const [selectedRole, setSelectedRole] = useState([])

  useEffect(() => {
    if (adminType === 'sys_admin') dispatch(systemGetUser({ queries: { id } }))
    else dispatch(retrieveCustomerAdminUserByID({ queries: { id } }))
  }, [])

  useEffect(() => {
    if (isNotEmpty(user?.roles)) {
      setUserRolesClone(Object.keys(user?.roles))
    }
  }, [user])

  const clearUpdatedUser = () => {
    if (adminType === 'sys_admin') dispatch(updateSelectedSystemAdminUserStore({ queries: {} }))
    else dispatch(customerAdminUpdateSelectedUser({ queries: {} }))
  }

  const changeStatusHandler = (status) => {
    if (adminType === 'sys_admin') {
      dispatch(
        systemChangeStatus({
          queries: {
            title: status,
            data: { id },
          },
        }),
      ).then((response) => {
        if (response.meta.requestStatus === 'fulfilled') {
          dispatch(systemGetUser({ queries: { id } }))
        }
      })
    }
  }

  const editUserHandler = () => {
    history.push(`${baseUri}/edit-user/${id}`)
  }

  return (
    <Box sx={styles.root}>
      <Box sx={styles.header}>
        <Box sx={styles.infoContainer}>
          <GoBackButton label={t?.['Back to Users']} customBackLink={adminType === 'sys_admin' ? '/users' : '/home'} andThisAction={clearUpdatedUser} />

          <Box sx={styles.headerInfo}>
            <Avatar alt='profileImage' sx={styles.profileImage} src={defaultImage} />
            <Box sx={{ marginLeft: '15px' }}>
              <Typography sx={styles.headerText}>
                <HoverTooltip title={user?.fullName || user?.name}>
                  {getUserName(user?.fullName || user?.name, isSmScreen) || `${t?.['No Name']}`}
                </HoverTooltip>
              </Typography>
              <Typography sx={styles.subheaderText}>{user?.user_types?.join(' - ')}</Typography>
            </Box>
          </Box>
        </Box>
        <Box sx={styles.buttonContainer}>
          <SwitchBtn
            status={user?.active}
            disabled={adminType === 'customer_admin'}
            onClick={changeStatusHandler}
          />
          <OfoqThemeBtn name={t?.['Edit Profile']} onClick={editUserHandler} customStyle={styles.themeBtn} />
        </Box>
      </Box>
      <Box sx={styles.body}>
        <Grid container>
          <Grid item xs={12} md={8} lg={9}>
            <Box sx={styles.bodyContainer}>
              <Typography sx={[styles.titleSectionHeader, { fontWeight: 'typography.fontWeightBold',
              }]}>
                {t?.['Basic Information']}
              </Typography>
              <Box sx={styles.infoBox}>
                <Typography>{t?.['Full Name']}</Typography>
                <Typography>
                <HoverTooltip title={user?.name}>
                  {getUserName(user?.name, isSmScreen) || ''}
                </HoverTooltip>

                </Typography>
              </Box>
              <Box sx={styles.infoBox}>
                <Typography>{t?.['Email Address']}</Typography>
                <Typography>
                  <HoverTooltip title={user?.email}>
                {`${user?.email?.slice(0, 20)} ${user?.email?.length > 20 ? '...' : ''}`}
                  </HoverTooltip>
                </Typography>
              </Box>
              {adminType === 'sys_admin' && (
                <Box sx={styles.infoBox}>
                  <Typography>{t?.Company}</Typography>
                  <Typography>{user?.company?.name || ''}</Typography>
                </Box>
              )}
            </Box>
            {userRolesClone.length > 0 && (
              <Box sx={styles.bodyContainer}>
                <Typography sx={[styles.titleSectionHeader, { fontWeight: 'typography.fontWeightBold',
                }]}>
                  {t?.['Role Information']}
                </Typography>

                {userRolesClone?.map((role, index) => (
                  <Box sx={[styles.infoBox, !isNotEmpty(user?.roles?.[role]) && { display: 'none' }]} key={role}>
                    <Typography>{`${index + 1}. ${role}`}</Typography>
                    <Box>
                      <Typography component='span'
                      sx={styles.userRoles}
                      >
                        {user?.roles?.[role]?.slice(0, 2)?.map((singleRole) => singleRole.display_name)?.join(', ')}

                      </Typography>
                      {user?.roles?.[role]?.length > 2 &&
                        <Typography
                          component='span'
                          sx={{ color: '#29CC8B !important', cursor: 'pointer' }}
                          onClick={() => {
                            setSelectedRole(user?.roles?.[role])
                            setModelState(true)
                          }}
                        >
                          {' '}
                          + {user?.roles?.[role]?.length &&
                          (user?.roles?.[role]?.length || 0) - 2} {t?.More}
                        </Typography>
                      }
                    </Box>
                  </Box>

                ))}
              </Box>
            )}
          </Grid>
            <Grid item md={4} lg={3} sx={styles.imageContainer}>
            <img src={completeInfoImage} alt='complete-profile-art' />
          </Grid>
        </Grid>
      </Box>
      <FormModalContainer
        modalState={modelState}
        handleClose={() => setModelState(false)}
        modalTitle={t?.['User Roles']}
        customStyle={styles.userRolesModal}
      >
        {selectedRole?.map((singleRole) => <Typography key={singleRole?.display_name}>
          {singleRole?.display_name}
        </Typography>)
        }
        <Box sx={styles.formModalBtnsContainer}>
          <OfoqThemeBtn
            onClick={() => setModelState(false)}
            name={t?.Close}
            customStyle={styles.closeBtn}
          />
        </Box>

      </FormModalContainer>
    </Box>
  );
}

const styles = {
  root: {
    marginTop: { xs: '-9px', sm: '-27px' },
  },
  header: {
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    alignItems: { xs: 'stretch', sm: 'center' },
    justifyContent: { xs: 'center', md: 'space-between' },
    padding: { xs: '5px 20px 20px', sm: '20px 30px', md: '20px 80px' },
  },
  headerInfo: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  GoBackButton: {
    display: 'flex',
    alignItems: 'center',
    color: 'text.hint',
    textDecoration: 'none',
    marginBottom: '10px',
    '.MuiTypography-root': {
      fontSize: '12px',
    },
    '& svg': {
      fontSize: '16px',
    },
  },
  headerText: {
    fontSize: { xs: '16px', sm: '24px' },
  },
  subheaderText: {
    fontSize: { xs: '10px', sm: '14px' },
    color: 'text.hint',
  },
  profileImage: {
    width: { xs: 50, sm: 80 },
    height: { xs: 50, sm: 80 },
    borderRadius: { xs: '7px', sm: '10px' },
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: { xs: 'space-between', sm: 'flex-end' },
    marginTop: '20px',
  },
  themeBtn: {
    padding: { xs: '0 20px', sm: '0 30px' },
    minWidth: 'fit-content',
    height: { xs: '30px', sm: '40px' },
    marginLeft: { xs: '25px', sm: '40px' },
    fontSize: { xs: '12px', sm: '14px' },
  },
  body: {
    margin: { xs: '20px', sm: '40px 80px' },
  },
  bodyContainer: {
    padding: '20px',
    margin: { xs: '0 0 20px 0', sm: '0 0 40px 20px' },
    backgroundColor: 'white',
    borderRadius: '15px',
    border: 'solid 1px #e2e8ee',
    '.MuiTypography-root': {
      marginBottom: '15px',
    },
  },
  titleSectionHeader: {
    fontSize: { xs: '14px', sm: 'unset' },
  },
  infoBox: {
    display: 'flex',
    justifyContent: 'space-between',
    '.MuiTypography-root': {
      fontSize: { xs: '12px', sm: '14px' },
      color: 'text.hint',
    },
  },
  formModalBtnsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    margin: { xs: '10px -15px 0 -15px', sm: '20px -15px 0 -15px' },
    padding: { xs: '10px 10px 0', sm: '20px 15px 0' },
    borderTop: '1px solid #cbcbcb',

  },
  closeBtn: {
    height: { xs: '30px', sm: '40px' },
  },
  userRoles: {
    color: '#92929D',
    fontFamily: 'Avenir',
    fontSize: '14px',
    fontweight: 500,
  },
  userRolesModal: {
    '& h6': {
      fontSize: { xs: '16px', sm: 'unset' },
    },
    '& p': {
      fontSize: { xs: '14px', sm: 'unset' },
    },
  },
  imageContainer: {
    display: { xs: 'none', md: 'block' },
    '& img': {
      maxWidth: '300px',
      height: '400px',
    },
  },
}

export default Index
